import { useEffect } from "react";

export default function ClearFilters(props) {
  const setFilters = props.setFilters;
  const filters = props.filters;
  const setShowCoordinates = props.setShowCoordinates;
  const showCoordinates = props.showCoordinates;

  const initialState = {
    coordinates: {
      eastLongitude: "",
      northLatitude: "",
      southLatitude: "",
      westLongitude: "",
    },
    keywords: [],
    researchPlatform: [],
    publicationYear: "",
    duration: {
      start: "",
      end: "",
    },
    publisher: [],
  };

  const handleClearFilter = (e) => {
    setFilters(initialState);
    setShowCoordinates(false);

    props.removeParam("researchPlatform");
    props.removeParam("keywords");
    props.removeParam("startDate");
    props.removeParam("endDate");
    props.removeParam("publisher");
    props.removeParam("publicationYear");
    props.removeParam("northLat");
    props.removeParam("southLat");
    props.removeParam("westLong");
    props.removeParam("eastLong");
  };

  return (
    <>
      <button
        onClick={handleClearFilter}
        type="button"
        className="w-1/8 justify-center mr-2 inline-flex items-start px-4 py-2.5 text-sm leading-4 border font-medium rounded-md shadow-sm text-gray-700 bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
      >
        Clear Filters
      </button>
    </>
  );
}